<template>
  <div class="widget widget-sales-category" style="min-height: 460px;">
    <div class="widget-heading">
      <h5>Statusy ofert</h5>
      <div>
        <ejs-daterangepicker
            id="statusesOffersId"
            placeholder="Wybierz zakres dat"
            :value="dateRange"
            :format="dateFormat"
            @change="onDateChange"
        ></ejs-daterangepicker>
      </div>
    </div>

    <template v-if="isLoading">
      <div class="text-center my-3">
        <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-danger">Ładowanie...</div>
      </div>
    </template>

    <template v-else>
      <div class="widget-content" v-if="statusesCounts.length > 0">
        <vue-apexcharts height="500" type="donut" :options="sales_options" :series="statusesCounts"></vue-apexcharts>
      </div>
    </template>

  </div>
</template>

<script>
import {onMounted, ref} from "vue";
import store from "../../../store";
import axios from "axios";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import vueApexcharts from "vue3-apexcharts";
import {DateRangePickerComponent} from "@syncfusion/ej2-vue-calendars";

export default {
  components: {'ejs-daterangepicker': DateRangePickerComponent, vueApexcharts},

  props: {
    glowiceOnly: {type: Boolean, default: false},
  },

  data() {
    const today = new Date();
    const _startDate = new Date(today);
    _startDate.setMonth(_startDate.getMonth() - 1); // Ustaw na jeden miesiąc przed dzisiejszą datą
    const _endDate = new Date(today); // Ustaw dzisiejszą datę

    return {
      isLoading: false,
      dateRange: [_startDate, _endDate], // Początkowy zakres dat
      dateFormat: 'dd/MM/yyyy', // Format daty
      sales_options: {},
      statusesCounts: [],
      statusesNames: [],
      statusesColors: [],
      is_dark: store.state.is_dark_mode
    }
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    onDateChange(args) {
      this.dateRange = args.value;
      this.fetchData();
    },

    fetchData() {
      this.isLoading = true;
      axios.post(route("graphs.statusesOffers"), {
        'glowiceOnly': this.glowiceOnly,
        dates: this.dateRange
      })
          .then(response => {
            this.statusesCounts = response.data.statusesCounts;
            this.statusesNames = response.data.statusesNames;
            this.statusesColors = response.data.statusesColors;

            this.sales_options = {
              chart: {},
              dataLabels: {enabled: false},
              legend: {
                position: "bottom",
                horizontalAlign: "center",
                fontSize: "18px",
                markers: {width: 10, height: 10},
                height: 90,
                offsetY: 10,
                itemMargin: {horizontal: 8, vertical: 0},
              },
              plotOptions: {
                pie: {
                  donut: {
                    size: "65%",
                    background: "transparent",
                    labels: {
                      show: true,
                      name: {
                        show: true,
                        fontSize: "25px",
                        offsetY: -10,
                      },
                      value: {
                        show: true,
                        fontSize: "30px",
                        fontFamily: "Arimo, sans-serif",
                        color: this.is_dark ? "#bfc9d4" : undefined,
                        offsetY: 16,
                        formatter: function (val) {
                          return val;
                        },
                      },
                      total: {
                        show: true,
                        label: "Suma",
                        color: "#888ea8",
                        fontSize: "40px",
                        formatter: function (w) {
                          return w.globals.seriesTotals.reduce(function (a, b) {
                            return a + b;
                          }, 0);
                        },
                      },
                    },
                  },
                },
              },
              expandOnClick: this.is_dark,
              stroke: {show: true, width: 15, colors: this.is_dark ? "#0e1727" : "#fff"},
              colors: this.statusesColors,
              labels: this.statusesNames,
              responsive: [],
            };
          })
          .catch(error => {
            console.error("Error:", error);
          }).finally(() => {
        this.isLoading = false;
      });
    }
  }
};
</script>
